import pool from '../components/pools/_poolState'

export default {
  state: {
    pool,
    accounts: [],
    loading: false,
    userLangs: [
      {text: 'Magyar', value: 'hu'},
      {text: 'Angol', value: 'en'}
    ],
  },
  mutations: {
    updateState(state, {key, value}) {
      state[key] = Object.assign(state[key], value)
    },
    enableLoading(state) {
      state.loading = true
      document.getElementsByTagName('body')[0].classList.add('loading')
    },
    disableLoading(state) {
      state.loading = false
      document.getElementsByTagName('body')[0].classList.remove('loading')
    }
  },
  actions: {
    interceptResponse({commit, state}, response) {
      if (typeof response !== 'undefined' && typeof response.data !== 'undefined' && typeof response.data.global !== 'undefined') {
        Object.keys(response.data.global).forEach(key => {
          commit('updateState', {key, value: response.data.global[key]})
        })
      }
    },
    loadGlobal({commit}, globalState) {
      Object.keys(globalState).forEach(key => {
        commit('updateState', {key, value: globalState[key]})
      })
    }
  }
}